import script from "./SourcesSchema.vue?vue&type=script&setup=true&lang=js"
export * from "./SourcesSchema.vue?vue&type=script&setup=true&lang=js"

import "./SourcesSchema.vue?vue&type=style&index=0&id=634b4473&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634b4473"]])

export default __exports__